import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5185a71d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-ltl-order" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_excel_multiple_modal = _resolveComponent("excel-multiple-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_step_company = _resolveComponent("step-company")!
  const _component_step_senders = _resolveComponent("step-senders")!
  const _component_new_additional_services = _resolveComponent("new-additional-services")!
  const _component_step_date = _resolveComponent("step-date")!
  const _component_step_time_slots = _resolveComponent("step-time-slots")!
  const _component_step_receivers = _resolveComponent("step-receivers")!
  const _component_step_cargo = _resolveComponent("step-cargo")!
  const _component_step_delivery_time_slots = _resolveComponent("step-delivery-time-slots")!
  const _component_step_create = _resolveComponent("step-create")!
  const _component_completed_cargos = _resolveComponent("completed-cargos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.excel_multiple_state.is_opened)
      ? (_openBlock(), _createBlock(_component_excel_multiple_modal, {
          key: 0,
          "company-id": _ctx.state.company_id,
          onCancel: _ctx.closeExcelMultipleModal,
          onOrderCreated: _ctx.onExcelMultipleOrderCreated
        }, null, 8, ["company-id", "onCancel", "onOrderCreated"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Создание LTL заказа" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_step_company, {
      class: "mt-6",
      "step-number": 1,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      "company-id": _ctx.state.company_id,
      onSubmit: _ctx.onCompanySubmit,
      onReset: _ctx.onCompanyReset
    }, null, 8, ["disabled", "company-id", "onSubmit", "onReset"]),
    _createVNode(_component_step_senders, {
      class: "mt-6",
      "excel-multiple-order": "",
      "step-number": 2,
      opened: _ctx.isCompanySelected,
      "company-id": _ctx.state.company_id,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      onSubmit: _ctx.onSenderSubmit,
      onReset: _ctx.onSenderReset,
      onExcelMultipleOrder: _ctx.openExcelMultipleModal
    }, null, 8, ["opened", "company-id", "disabled", "onSubmit", "onReset", "onExcelMultipleOrder"]),
    _createVNode(_component_new_additional_services, {
      class: "mt-6",
      "is-sender": "",
      opened: _ctx.isCompanySelected,
      "additional-services": _ctx.state.additional_services,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      "initial-value": _ctx.state.sender_additional_services,
      "is-setted": _ctx.state.is_sender_additional_services_setted,
      "is-update": _ctx.state.is_sender_additional_services_update,
      onSubmit: _ctx.onSubmitSenderAdditionalServices,
      onUpdate: _ctx.onStartUpdateSenderAdditionalServices
    }, null, 8, ["opened", "additional-services", "disabled", "initial-value", "is-setted", "is-update", "onSubmit", "onUpdate"]),
    _createVNode(_component_step_date, {
      class: "mt-6",
      date: _ctx.state.send_date,
      "onUpdate:date": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.send_date) = $event)),
      period: _ctx.state.send_period,
      "onUpdate:period": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.send_period) = $event)),
      "step-number": 4,
      opened: _ctx.isSenderSelected,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      onSubmit: _ctx.onDateSubmit,
      onReset: _ctx.onDateReset
    }, null, 8, ["date", "period", "opened", "disabled", "onSubmit", "onReset"]),
    (_ctx.take_time_slot_state.is_enabled)
      ? (_openBlock(), _createBlock(_component_step_time_slots, {
          key: 1,
          class: "mt-6",
          title: "Выберите тайм-слот при заборе",
          "selected-text": "Выбранный тайм-слот при заборе",
          opened: _ctx.isSenderSelected,
          completed: _ctx.take_time_slot_state.is_completed,
          "company-id": _ctx.state.company_id,
          sender: _ctx.take_time_slot_state.sender,
          date: _ctx.state.send_date,
          disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
          modelValue: _ctx.take_time_slot_state.timeSlot,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.take_time_slot_state.timeSlot) = $event)),
          onSubmit: _ctx.onTakeTimeSlotSubmit,
          onUpdate: _ctx.onTakeTimeSlotReset
        }, null, 8, ["opened", "completed", "company-id", "sender", "date", "disabled", "modelValue", "onSubmit", "onUpdate"]))
      : _createCommentVNode("", true),
    _createVNode(_component_step_receivers, {
      class: "mt-6",
      "with-excel": "",
      "step-number": 5,
      opened: _ctx.isTakeTimeSlotSelected && !_ctx.delivery_time_slot_state.is_component_showed,
      "sender-id": _ctx.state.sender_id,
      "sender-city-id": _ctx.state.sender_city_id,
      "company-id": _ctx.state.company_id,
      receiver: _ctx.state.receiver,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      "selected-receivers-ids": _ctx.selectedReceiversIds,
      "excel-loading": _ctx.state.is_excel_loading,
      hint: _ctx.LTLHintText,
      onSubmit: _ctx.onReceiverSubmit,
      onReset: _ctx.onReceiverReset,
      onCreateFromExcel: _ctx.onCreateFromExcel
    }, null, 8, ["opened", "sender-id", "sender-city-id", "company-id", "receiver", "disabled", "selected-receivers-ids", "excel-loading", "hint", "onSubmit", "onReset", "onCreateFromExcel"]),
    _createVNode(_component_step_cargo, {
      class: "mt-6",
      "step-number": 6,
      "additional-services": _ctx.state.additional_services,
      opened: _ctx.isReceiverSelected,
      "is-update": _ctx.state.is_updating_cargo,
      "updating-cargo-index": _ctx.state.updating_cargo_index,
      "updating-cargo": _ctx.state.updating_cargo,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      "company-id": _ctx.state.company_id,
      "company-verify": _ctx.state.company_verify,
      "sender-city-id": _ctx.state.sender_city_id,
      receiver: _ctx.state.receiver,
      "receiver-city-type": _ctx.state.receiver ? _ctx.state.receiver.city_type : null,
      "sender-city-dispatcher-sector-id": _ctx.state.sender_dispatcher_sector_id,
      "is-cash-enabled-by-setting": _ctx.state.sender_cash_enabled,
      "is-kaspi-enabled-by-setting": _ctx.state.sender_kaspi_enabled,
      "is-shipment-type-express3-hours-enabled-by-setting": _ctx.state.sender_shipment_type_3_hour_enabled,
      "is-shipment-type-express-day-to-day-enabled-by-setting": _ctx.state.sender_shipment_type_day_to_day_enabled,
      onSubmit: _ctx.onCargoSubmit,
      onCancelUpdate: _ctx.cancelUpdateCargo,
      "is-no-cash-input": ""
    }, null, 8, ["additional-services", "opened", "is-update", "updating-cargo-index", "updating-cargo", "disabled", "company-id", "company-verify", "sender-city-id", "receiver", "receiver-city-type", "sender-city-dispatcher-sector-id", "is-cash-enabled-by-setting", "is-kaspi-enabled-by-setting", "is-shipment-type-express3-hours-enabled-by-setting", "is-shipment-type-express-day-to-day-enabled-by-setting", "onSubmit", "onCancelUpdate"]),
    (_ctx.delivery_time_slot_state.is_component_showed)
      ? (_openBlock(), _createBlock(_component_step_delivery_time_slots, {
          key: 2,
          class: "mt-6",
          "company-id": _ctx.state.company_id,
          "sender-city-id": _ctx.state.sender_city_id,
          "sender-data-time": _ctx.senderDataTimeForDeliveryTimeSlot,
          cargo: _ctx.cargoForDeliveryTimeSlot,
          disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
          onSubmit: _ctx.onDeliveryTimeSlotSubmit
        }, null, 8, ["company-id", "sender-city-id", "sender-data-time", "cargo", "disabled", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.state.completed_cargos.length >= 5 && !_ctx.state.is_order_created && !_ctx.delivery_time_slot_state.is_component_showed)
      ? (_openBlock(), _createBlock(_component_step_create, {
          key: 3,
          class: "mt-6",
          loading: _ctx.state.is_creating_order,
          onSubmit: _ctx.onSubmitOrder
        }, null, 8, ["loading", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_completed_cargos, {
      class: _normalizeClass({
                'mt-6': _ctx.state.completed_cargos.length < 5,
                'mt-3': _ctx.state.completed_cargos.length >= 5,
            }),
      cargos: _ctx.state.completed_cargos,
      disabled: _ctx.state.is_creating_order || _ctx.state.is_order_created,
      "additional-services": _ctx.state.additional_services,
      "is-bosch": _ctx.isBosch,
      onDeleteCargo: _ctx.onDeleteCargo,
      onUpdateCargo: _ctx.onStartUpdateCargo,
      onUpdateAdditionalServices: _ctx.onUpdateCompletedCargoAdditionalServices
    }, null, 8, ["class", "cargos", "disabled", "additional-services", "is-bosch", "onDeleteCargo", "onUpdateCargo", "onUpdateAdditionalServices"]),
    (_ctx.state.completed_cargos.length > 0 && _ctx.isDateSelected && !_ctx.delivery_time_slot_state.is_component_showed)
      ? (_openBlock(), _createBlock(_component_step_create, {
          key: 4,
          class: "mt-3",
          created: _ctx.state.is_order_created,
          loading: _ctx.state.is_creating_order,
          onSubmit: _ctx.onSubmitOrder,
          onNewOrder: _ctx.resetOrder
        }, null, 8, ["created", "loading", "onSubmit", "onNewOrder"]))
      : _createCommentVNode("", true)
  ]))
}